import { render, staticRenderFns } from "./FormAnotacoesCadastro.vue?vue&type=template&id=9834dbee&"
import script from "./FormAnotacoesCadastro.vue?vue&type=script&lang=js&"
export * from "./FormAnotacoesCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports